/**
 * 特定のページに限定せず使われるもの
 */

import { BREAKPOINTS } from "./constants/breakpoints";
import debounce from 'lodash.debounce';

export default class Common {
   constructor() {
      this.$window = $(window);
      this.$globalNav = $('.js-globalNav');
      this.globalNavHeight = this.$globalNav.outerHeight();//borderを含めナビゲーションのheightを取得
      this.windowWidth = window.innerWidth; // ブラウザのスクロールバーも含めて横幅を取得
      this.windowHeight = window.innerHeight;
      this.beforeWidth = this.windowWidth;
      this.scrollCount = null;

      this.setEventHandlers();
      this.toggleHamburgerMenu();

      this.formPage();

      if ($('.js-property-contact-form-wrapper').find('.mw_wp_form_complete').length || $('.js-property-contact-form-wrapper').find('.error').length) {
         $('.js-hide-target').hide();
         $('#contact-modal').modal({
            fadeDuration: 250,
            fadeDelay: 0.80
         });
      }

      if ($('.js-general-contact-form-wrapper').find('.mw_wp_form_complete').length) {
         const $clone = $('.mw_wp_form_complete').clone();
         $('.js-form-complete-modal-content').append($clone);
         $('#form-complete-modal').modal({
            fadeDuration: 250,
            fadeDelay: 0.80
         });
      }

      if (this.windowWidth < BREAKPOINTS.SMALL) {
         // console.log("smaller than SMALL!");
      } else if (this.windowWidth < BREAKPOINTS.MEDIUM) {
         // console.log("smaller than MEDIUM!");
      } else if (this.windowWidth < BREAKPOINTS.LARGE) {
         this.switchImgResponsive(this.windowWidth);
         this.switchBgImgResponsive(this.windowWidth);
      } else {
         this.toggleGlobalNavigation();
         this.switchImgResponsive(this.windowWidth);
         this.switchBgImgResponsive(this.windowWidth);
      }
      this.$window.on('resize', debounce(() => {
         this.windowWidth = window.innerWidth;
         this.windowHeight = window.innerHeight;
         if (this.windowWidth < BREAKPOINTS.SMALL) {
            // iOS/Androidではスクロールした時にurlバーが表示・非表示される度にresizeイベントが発火するため
            // resize発火後に縦横が変わったときだけresizeとみなして処理する（横幅に変化がなければキャンセル）
            if (this.beforeWidth == this.windowWidth) {
               return;
            } else {//ランドスケープになったときの処理
               this.switchImgResponsive(this.windowWidth);
               this.switchBgImgResponsive(this.windowWidth);
            }
            // 横幅を更新
            this.beforeWidth = this.windowWidth;
         } else if (this.windowWidth < BREAKPOINTS.MEDIUM) {
            if (this.beforeWidth == this.windowWidth) {
               return;
            } else {
               this.switchImgResponsive(this.windowWidth);
               this.switchBgImgResponsive(this.windowWidth);
            }
            this.beforeWidth = this.windowWidth;
         } else if (this.windowWidth < BREAKPOINTS.LARGE) {
            if (this.beforeWidth == this.windowWidth) {
               return;
            } else {
               this.switchImgResponsive(this.windowWidth);
               this.switchBgImgResponsive(this.windowWidth);
            }
            this.beforeWidth = this.windowWidth;
         } else {
            // BREAKPOINTS.LARGE以上のサイズでは横幅の変化でも処理をする
            this.switchImgResponsive(this.windowWidth);
            this.switchBgImgResponsive(this.windowWidth);
            this.beforeWidth = this.windowWidth;
         }
      }, 500));
   }

   setEventHandlers() {
      $('.js-stopPropagation').on('click', (e) => {
         this.stopPropagation(e);
      });
      $('.js-nestedContentToggleTrigger').on('click', (e) => {
         this.toggleNestedContent(e);
      });
      $('[data-toggle-target]').on('click', (e) => {
         this.collapse(e);
      });
      $('[data-href]').on('click', (e) => {
         this.linkManual(e);
      });
      $('[data-bulk-check-area]').on('change', (e) => {
         this.onChangeBulkAreaCheck(e);
     });
   }

   //ハンバーガーメニューの開閉
   toggleHamburgerMenu() {
      let scrollPosition = null;
      $('.js-globalNavTriggerBtn').on('click', (e) => {
         const $body = $('body');
         const navStatus = $('body').attr('data-nav-status');
         // $('.js-globalNavToggleContent').slideToggle();
         $('.js-globalNavToggleContent').toggleClass('is-open');
         $(e.currentTarget).toggleClass('is-open');
         if (!navStatus || navStatus == 'is-close') {
               scrollPosition = this.$window.scrollTop();
               $body.attr('data-nav-status', 'is-open');
               $body.css('top', -scrollPosition);
               $('.js-nav-mask').css('top', scrollPosition);
         } else {
               $body.attr('data-nav-status', 'is-close');
               $body.removeAttr('style');
               window.scrollTo(0, scrollPosition);
         }
      });
      $('.js-nav-mask').on('click', function () {
         $('body').attr('data-nav-status', 'is-close').removeAttr('style');
         window.scrollTo(0, scrollPosition);
         $('.js-globalNavToggleContent, .js-globalNavTriggerBtn').removeClass('is-open');
      });
   }

   //スクロールに応じたglobal navigationの表示制御
   toggleGlobalNavigation() {
      let startScrollPos = 0;
      this.$window.on('scroll', debounce(() => {
         this.scrollCount = this.$window.scrollTop();
         if (this.scrollCount > startScrollPos) {
            //下方向のスクロール時
            if (this.scrollCount > this.globalNavHeight) {
               this.$globalNav.removeClass('is-show').addClass('is-hide');
               this.$globalNav.on('transitionend', () => {
                  this.$globalNav.addClass('is-fixed');
               });
            } else {
               this.$globalNav.removeClass('is-hide is-show');
            }
         } else {
            //上方向のスクロール時
            this.$globalNav.removeClass('is-hide').addClass('is-show');
            if (this.scrollCount < this.globalNavHeight) {
               this.$globalNav.removeClass('is-hide is-show');
               this.$globalNav.on('transitionend', () => {
                  this.$globalNav.removeClass('is-fixed');
               });
            }
         }
         startScrollPos = this.$window.scrollTop();
      }, 200));
   }

   //ページ遷移時にアンカーリンク指定があった場合にfixedヘッダー分の位置を調整
   fixAnkerLinkScrollPosition() {
      //URLのハッシュ値を取得
      const urlHash = location.hash;
      //ハッシュ値があればページ内スクロール
      if (urlHash) {
         const targetPosition = $(urlHash).offset().top;
         $(window).scrollTop(targetPosition - this.globalNavHeight);
      }
   }

   //イベント伝播ストップIE対応
   stopPropagation(e) {
      if (e.stopPropagation) {
         e.stopPropagation();
      } else {
         e.cancelBubble = true;
      }
   }

   //階層構造になっているメニューの開閉
   toggleNestedContent(e) {
      // 今のところpcでは無効
      if (this.windowWidth < BREAKPOINTS.LARGE) {
         const $toggleTriggers = $(e.currentTarget).closest('.js-nestedContentWrapper').find('.js-nestedContentToggleTrigger');
         if (!$(e.currentTarget).hasClass('is-open')) {
            // 表示中の兄弟要素を閉じる
            $toggleTriggers.removeClass('is-open').next('.js-nestedContent').slideUp();
         }
         $(e.currentTarget).next('.js-nestedContent').slideToggle();
         $(e.currentTarget).toggleClass('is-open');
      }
   }

   // モバイルファーストで設定した画像をdesktopサイズにswitchする
   // prPage.jsのswitchEyecatchImgSrc()はlandscape画像をデフォルトとして、オプショナルでスマホ用画像の設定ができるようにしている
   switchImgResponsive(windowWidth) {
      $('.js-switch-image-responsive').each((i, el) => {
         const smImgSrc = $(el).data('switch-image-sm');
         const lgImgSrc = $(el).data('switch-image-lg');
         if (windowWidth < BREAKPOINTS.SMALL) {
            if (smImgSrc) {
               $(el).attr('src', smImgSrc);
            }
         } else {
            if (lgImgSrc) {
               $(el).attr('src', lgImgSrc);
            }
         }
      });
   }
   switchBgImgResponsive(windowWidth) {
      $('.js-switch-bg-image-responsive').each((i, el) => {
         const smImgSrc = $(el).data('switch-bg-image-sm');
         const lgImgSrc = $(el).data('switch-bg-image-lg');
         if (windowWidth < BREAKPOINTS.SMALL) {
            if (smImgSrc) {
               $(el).css({ 'backgroundImage': `url(${smImgSrc})` });
            }
         } else {
            if (lgImgSrc) {
               $(el).css({ 'backgroundImage': `url(${lgImgSrc})` });
            }
         }
      });
   }

   collapse(e) {
      const target = $(e.currentTarget).data('toggle-target');
      $(`[data-toggle-id="${target}"]`).slideToggle('fast');
      $(e.currentTarget).toggleClass('is-show');
   }

   linkManual(e) {
      e.preventDefault();
      const href = $(e.currentTarget).data('href');
      window.location.href = href;
   }

   // //フォームでの細かい動き
   formPage() {
      if ($('.error', '#form-section').length) {
         // error画面になったら #form-section までスクロールした状態で表示させる
         $(window).scrollTop($('#form-section').offset().top - this.$globalNav.outerHeight());
         // errorの項目にclass付与
         $('.error', '#form-section').closest('.js-form-item').addClass('hasError');
         // エラーを伝えるモーダルを開く
         $('#form-error-modal').modal({
               fadeDuration: 250,
               fadeDelay: 0.80
         });
      }

      // selectboxのoptionが初期値（空の場合）に文字色をグレー#777にする処理
      const selectElements = document.querySelectorAll('.js-formSelectStyledEmptyOption');
      selectElements.forEach(function(selectElement) {
         selectElement.style.color = '#777';
         selectElement.addEventListener('change', function() {
            this.style.color = this.value === '' ? '#777' : '#000';
         });
      });
   }

   onChangeBulkAreaCheck (e) {
      const $target = $(e.currentTarget);
      const area = $target.data('bulk-check-area');
      const $items = $(`[data-bulk-check-area-items="${area}"]`);
      $items.find('input[type="checkbox"]').prop('checked', $target.prop('checked'));
  }
};

